import React, { Component, useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import CommonAlert from "../common/Commonalert";
import Sidebar from "../common/sidebar";
import ShowAlert from "../common/Showalert";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AddDepot = () => {
  const { t } = useTranslation();
  const { name } = useParams();
  const [mainDepot, setMainDepot] = useState("");
  const [subDepot, setSubDepot] = useState("");
  const [datalist, setDataList] = useState([]);
  const [errormsg, setErrormsg] = useState({});
  const [errors, setErrors] = useState({});
  const [errmessage, setErrMessage] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alerterrorPopup, setAlertErrorPopup] = useState(false);
  const [alerterrMessage, setAlerterrMessage] = useState([]);
  const [alertMessage, setAlertMessage] = useState([]);

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_masterentry")
  ) {
    window.location.href = "/unauthorized";
  }
  const routeChange = () => {
    window.location.href = `/depot`;
  };

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    let URL = BaseUrl + `admin/getdepots`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;

        setDataList(responseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const btnsubmit = (e) => {
    e.preventDefault();
    const isValid = formvalidation();
    if (isValid) {
      let payload = {
        mainDepot: mainDepot.trim(),
        subDepot: subDepot.trim(),
      };
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + "admin/adddepot/";
      http
        .post(URL, payload)
        .then(async (response) => {
          if (response.data.success === true) {
            setAlertPopup(true);
            setAlertMessage(t("depot_added_successfully_txt"));
            setTimeout(() => {
              routeChange();
            }, 2000);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const formvalidation = () => {
    const errmsg = {};
    let isValid = true;
    const hasDupicateEntry = datalist.some(
      (depot) =>
        depot.mainDepot.toLowerCase() === mainDepot.trim().toLowerCase() &&
        depot.subDepot.toLowerCase() === subDepot.trim().toLowerCase(),
    );
    if (!mainDepot.trim()) {
      errmsg.mainDepot = t("field_required_txt");
      isValid = false;
    }
    if (!subDepot.trim()) {
      errmsg.subDepot = t("field_required_txt");
      isValid = false;
    }
    if (hasDupicateEntry) {
      var alertmsg = "";
      alertmsg = t("duplicate_depot_error_txt");
      setAlertErrorPopup(true);
      setAlerterrMessage(alertmsg);
      isValid = false;
    }
    setErrors(errmsg);
    return isValid;
  };

  const handleOnChange = (e) => {
    const re = /^[a-zA-Z0-9-' &.]*$/;
    if (e.target.name === "mainDepot") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setMainDepot(e.target.value);
      }
    }
    if (e.target.name === "subDepot") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setSubDepot(e.target.value);
      }
    }
    const { name, value } = e.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  return (
    <section className="dashboard-block">
      {alerterrorPopup && (
        <ShowAlert title={t("alert_txt")} message={alerterrMessage} />
      )}
      {alertPopup && (
        <CommonAlert title={t("alert_txt")} message={alertMessage} />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <div className="right-table-outer-wrap">
              <h1 className="checkout-title">{t("add_depot_txt")}</h1>
              <div className="form-field freeproduct-fieldset masterentry-fieldset form-container-xs">
                <form className="sectors-detail-form">
                  <div className="input-field">
                    <label htmlFor="mainDepot">{t("main_depot_txt")}</label>
                    <input
                      type="text"
                      name="mainDepot"
                      id="mainDepot"
                      value={mainDepot}
                      onChange={handleOnChange}
                    />
                    {errors.mainDepot && (
                      <div className="error-msg">{errors.mainDepot}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <label htmlFor="subDepot">{t("local_depot_txt")}</label>
                    <input
                      type="text"
                      name="subDepot"
                      id="subDepot"
                      value={subDepot}
                      onChange={handleOnChange}
                    />
                    {errors.subDepot && (
                      <div className="error-msg">{errors.subDepot}</div>
                    )}
                  </div>
                  <div className="btnfield">
                    <button title={t("submit_txt")} type="submit" name="btnsubmit" onClick={btnsubmit}>
                      {t("submit_txt")}
                    </button>
                    <button title={t("cancel_txt")} type="button" onClick={routeChange}>
                      {t("cancel_txt")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};

export default AddDepot;
